module.exports = __webpack_public_path__ + "img/inco2.aeec5545.png";